import React from 'react';
import { isCosBrand } from "@pb/utils/brandConfig";
import cn from 'classnames';
import MetaText from "../../ui/Typography/texts/MetaText";
import styles from './ComparativePrice.module.scss';
const ComparativePrice = ({ unit, pricePerUnit, formattedPrice, quantity, comparativeQuantity, comparativePriceClassName, }) => {
    // TODO: Refactor this component when unit and pricePerUnit gets deprecated
    let outputQuantity = null;
    let formattedPriceAndQuantity = null;
    let output = null;
    if (quantity || formattedPrice || comparativeQuantity) {
        if (quantity)
            outputQuantity = quantity;
        if (formattedPrice && comparativeQuantity)
            formattedPriceAndQuantity = (React.createElement(React.Fragment, null,
                formattedPrice,
                " ",
                React.createElement("span", { role: "separator" }, "/"),
                " ",
                comparativeQuantity));
    }
    else if (unit || pricePerUnit) {
        if (unit)
            outputQuantity = unit;
        if (pricePerUnit)
            formattedPriceAndQuantity = pricePerUnit;
    }
    if (outputQuantity || formattedPriceAndQuantity) {
        if (isCosBrand) {
            output = React.createElement(React.Fragment, null, formattedPriceAndQuantity && formattedPriceAndQuantity);
        }
        else {
            output = (React.createElement(React.Fragment, null,
                outputQuantity && outputQuantity,
                outputQuantity && formattedPriceAndQuantity && React.createElement("span", { role: "separator" }, " | "),
                formattedPriceAndQuantity && formattedPriceAndQuantity));
        }
    }
    else {
        return null;
    }
    return (React.createElement(MetaText, { className: cn(styles.comparativePrice, isCosBrand && styles.cosStyling, comparativePriceClassName) }, output));
};
export default ComparativePrice;
//# sourceMappingURL=ComparativePrice.js.map